// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__34HSK","text":"SelectPayment_text__2MfRg","title":"SelectPayment_title__12AeJ","btn":"SelectPayment_btn__3lFU7"};